.root {
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 12px;
	line-height: 15px;
	color: var(--password-requirement-color);
	transition: color 0.15s ease-in-out;
}

.item[data-met] {
	color: #4caf50;
}

/* The check/cross glyphs are the same inline SVGs the legacy checklist uses
   (admin.less .check-mark-green / .cross-red). */
.icon {
	flex: 0 0 auto;
	width: 14px;
	height: 14px;
	background-repeat: no-repeat;
	background-position: center;
	background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='%23FF0000'%3E%3Cg %3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z' fill='%23FF0000'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
}

.item[data-met] .icon {
	background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' stroke='%23000000'%3E%3Cg%3E%3Cpath d='M4 12.6111L8.92308 17.5L20 6.5' stroke='%2366BB6A' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
}
